import Vue from 'vue';

const { detect } = require('detect-browser');
const browser = detect();

Object.defineProperties(Vue.prototype, {
  $browserInfo: {
    get: function() {
      return browser;
    }
  }
});



// WEBPACK FOOTER //
// ./src/plugins/DetectBrowser.js